<template>
  <base-dialog v-model="dialog.show" max-width="400px" min-width="400px" scrollable @close="onDialogClose"
    :title="`${titleDialog} thư mục`">
    <div id="app">
      <v-text-field v-model="folderForm.name" :rules="rulesName" color="purple darken-2" label="Tên thư mục"
        required></v-text-field>
    </div>
    <template #extra-btn>
      <base-button :loading="dialog.loading" color="primary" @click="create" v-if="dialog.type == EDIT_TYPE.CREATE">Thêm
        mới</base-button>
      <base-button color="primary" :loading="dialog.loading" @click="update" v-else>Cập nhật</base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { mapGetters } from 'vuex'
import { API_SYMBOL } from '@api'

export default {
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    img: '',
    cbId: '',
    file: null,
    errortext: '',
    rulesName: [
      (val) => (val || '').length > 0 || 'Tên thư mục không thể bỏ trống',
    ],
    folderForm: {
      name: 'Thư mục mới',
      type: 'folder',
      parent_id: null,
      id: null,
    },
    EDIT_TYPE,
  }),
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  watch: {
    dialog: {
      handler(value) {
        this.show = value
      },
      immediate: true,
    },
    show(value) {
      if (!value) this.$emit('close')
    },
  },
  mounted() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2)
  },
  methods: {
    open(item, folderType, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.folderForm = Object.assign(this.folderForm, item)
      this.folderForm.type = folderType
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
      this.errortext = ''
      this.folderForm = {
        name: 'Thư mục mới',
        parent_id: this.$route.params.id,
        type: null,
        id: null,
      }
    },
    getData() {
      this.$emit('reset')
    },
    close() {
      this.show = false
      this.$emit('close')
      this.imageArray = []
    },
    async create() {
      this.dialog.loading = true
      this.folderForm.parent_id = this.$route.params.id
      let res = await API_SYMBOL.createFolder(this.folderForm)
      if (res && !res.error) {
        this.onDialogClose()
        this.getData()
      }
      this.dialog.loading = false
    },
    async update() {
      this.dialog.loading = true
      let res = await API_SYMBOL.updateFolder(this.folderForm)
      if (res && !res.error) {
        this.onDialogClose()
        this.getData()
      }
      this.dialog.loading = false
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}

.select-image {
  height: 120px;
  width: 120px;
  border: 1px solid #cacfd2;
  cursor: pointer;
}

.select-image:hover {
  border: 1px solid;
}

.image-box {
  height: 120px;
  width: 120px;
  border: 1px solid #cacfd2;
  position: relative;
}
</style>
